export default "__VITE_ASSET__ruhMZV1d__"